import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";

import { LogInfo } from "../../common/FetchHelpers";

import LoadingComp from "../common/LoadingComp";

const ForgotPassComp = () => {
  const history = useHistory();
  const location = useLocation();

  const [showPage, setShowPage] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [showConfirmation, setshowConfirmation] = useState(false);

  const [showError, setShowError] = useState(false);
  const [messageData, setMessageData] = useState("");
  const [loading, setLoading] = useState(false);
  
  
  

  const [formData, setFormData] = useState({ userId: ""});

  const qparams = useParams();  
  let { from } = location.state || { from: { pathname: "/home"} };

  const getAppConfig = ()=>{
    //console.log('getAppConfig()');

    const responseFromServer = fetch('/auth/config', {
        method: "GET",
        cache: "no-cache",
      })
      .then(response => response.json())
      .then(data => {      
        if(data.sso){
          LogInfo("SSO configuration found.");
          if(qparams.ssouser){
            if(qparams.ssouser === "bypass")
            {
                setShowPage(true);
                setShowInput(true);
            }
          }
          else{
            window.location.replace(data.sso.ssoLoginUrl);
          }
        } else {
            setShowPage(true);
            setShowInput(true);
        }
      })
      .catch(error =>{
        console.error(error);
        //LogError(error);
      })

  }

  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };


  const handleSubmit = (event) => {
    //console.log('handleSubmit()');
    setLoading(true);
    event.preventDefault();
    if(formData.userId && formData.userId !== ''){
        fetch('/auth/ForgotPassword', {
        method: "POST",
        cache: "no-cache",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: formData.userId}),
        })
        .then(response => response.json())
        .then(result => {
            if(result.success === true){
                setShowInput(false);
                setMessageData(result.message);
                setshowConfirmation(true);
            }
            else{
                setLoading(false);
                setShowError(true);        
            }
        })
        .catch(error => {
        setLoading(false);
        setShowError(true);
        });
    }
    else{
        setLoading(false);
        setShowError(true);
    }
  };

  

  useEffect(() => {
    //console.log('useEffect: getAppConfig()');
    getAppConfig();
  }, []);


  return (
    
      <div className="center-container">

        {showPage ? (

        <form onSubmit={handleSubmit} className="form login-form" id="login-page">
          <h3 className="login-header">Forgot Password</h3>
            {showInput && (
          <div className="form-body">
            <div className="form-row">
              <div className="form-item">
                <label className="form-item-label-short">User ID : </label>
                <input name="userId" className="form-item-value" type="text" placeholder="userId" onChange={handleChange} disabled={loading ? "disabled" : ""}/>
              </div>
            </div>
          </div>
            )}
           {showInput ? ( 
          <div className="form-footer">
            <div className="form-status red">
              {showError && (
                <div className="form-status red">
                  UserID cannot be empty.
                </div>
              )}
              {loading && <LoadingComp small={true} />}
            </div>
            <div className="btn-group">
              <button id="btnForgotPassword" type="submit" className="btn btn-primary">
                Forgot Password
              </button>
              <button id="btnCancel" type="submit" className="btn btn-primary" onClick={()=>{history.push('/Login')}}>
                Cancel
              </button>
            </div>
          </div>
           ):(
            <div className="form-body">
            {showConfirmation && (
                <div >
              <div className="form-desc">
                  {messageData}
              </div>
              <div className="info-label"></div>
              <div  className="center-container">
                    <button id="btnBackToLoginPage" className="btn btn-primary" onClick={()=>{history.push('/Login')}}>
                        Back To Login Page
                    </button>
               </div>                          
            </div>
            
              )}
        </div>

           )}
        </form>
        ):(
          <div>Please wait...</div>
        )}
      </div>
    
  );
};

export default ForgotPassComp;
